



































































import { Component, Vue, Prop } from "vue-property-decorator";
import Gailan from "./shijuangailan.vue";
import { GetTestQuestionsList$ } from "@/request/jxgl";
import Danxuan from "./danxuan.vue";
import Duoxuan from "./duoxuan.vue";
@Component({
  components: {
    Gailan,
    Danxuan,
    Duoxuan,
  },
})
export default class SjkPreview extends Vue {
  private test: any = {
    create_time: "",
  };
  private filters: any = {
    current_page: 1,
    total_count: 0,
    total_page: 0,
    page_count: 5,
  };
  /**
   * @description 返回试卷库列表页
   */
  private backSjkList() {
    this.$router.push({
      path: "/main/jxgl/sjk-list",
    });
  }
  /**
   * @description 获得试卷详情
   */
  private fetchDetail() {
    const params: any = {
      test_id: this.test.test_id,
      current_page: this.filters["current_page"],
      page_count: this.filters["page_count"],
    };
    GetTestQuestionsList$(this, params).then((data: any) => {
      this.$set(this, "test", data);
      this.filters.total_count = data.total_count;
      this.filters.total_page = data.total_page;
    });
  }
  /**
   * @description 上一页
   */
  private prev() {
    this.filters.current_page--;
    this.fetchDetail();
  }
  /**
   * @description 下一页
   */
  private next() {
    this.filters.current_page++;
    this.fetchDetail();
  }
  /**
   * @description 跳转编辑
   */
  private jumpCompose() {
    this.$router.replace({
      path: "/main/jxgl/sjk-detail",
      query: {
        id: this.test.test_id,
      },
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.$route.query.id) {
      this.test.test_id = this.$route.query.id;
      this.fetchDetail();
    } else {
      this.$message.error("参数有误，请重新预览");
    }
  }
}
